<template>
    <div class="footer">
        <!-- 环保理念 -->
        <div class="flex-center">
            <div class="flex-row env" :style="'background:' + conceptBg">
                <div class="img-container" @click="goCore">
                    <div class="image-overlay">
                        <img src="/static/img/index/env.jpg" class="env-pic"/>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 底部导航 -->
        <div class="footer-nav">
            <div class="flex-row justify-between">
                <div class="footer-left">
                    <img class="logo align-start" src="/static/img/logo.png"/>
                    <p>{{$t('ContactUs.p1')}}</p>
                    <p>{{$t('ContactUs.p2')}}</p>
                    <p>{{$t('ContactUs.p3')}}</p>
                    <p>{{$t('ContactUs.p4')}}</p>
                </div>
                <div class="footer-right flex-row justify-around">
                    <!-- 关于我们 -->
                    <div class="menu-container" @mouseenter="activeMenu = 'about'" @mouseleave="activeMenu = null">
                        <router-link class="menu-title" to="/home/about">{{$t("menu.l2")}}</router-link>
                        <transition name="slide-down">
                            <div class="submenu" v-show="activeMenu === 'about'">
                                <div class="menu-item" @click="goAbout('#brand-intro')">{{lang == 'zh' ? '品牌简介' : 'Brand Introduction'}}</div>
                                <div class="menu-item" @click="goAbout('#brand-concept')">{{lang == 'zh' ? '品牌理念' : 'Brand Concept'}}</div>
                                <!-- <div class="menu-item" @click="goAbout('#enterprise-news')">{{lang == 'zh' ? '企业动态' : 'Company News'}}</div> -->
                            </div>
                        </transition>
                    </div>

                    <!-- 裕林科技板 -->
                    <div class="menu-container" @mouseenter="activeMenu = 'yulin'" @mouseleave="activeMenu = null">
                        <router-link class="menu-title" to="/home/yulin/0">{{$t("menu.l3")}}</router-link>
                        <transition name="slide-down">
                            <div class="submenu" v-show="activeMenu === 'yulin'">
                                <div class="menu-item" v-for="(item, index) in scenes" :key="index" @click="goScene(index)">
                                    {{lang == 'zh' ? item.zh : item.en}}
                                </div>
                            </div>
                        </transition>
                    </div>

                    <!-- 产品中心 -->
                    <div class="menu-container" @mouseenter="activeMenu = 'product'" @mouseleave="activeMenu = null">
                        <router-link class="menu-title" to="/home/product">{{$t("menu.l4")}}</router-link>
                        <transition name="slide-down">
                            <div class="submenu" v-show="activeMenu === 'product'">
                                <div class="menu-item" v-for="(item, index) in spaces" :key="index" @click="goSpace(index)">
                                    {{lang == 'zh' ? item.zh : item.en}}
                                </div>
                            </div>
                        </transition>
                    </div>

                    <!-- 核心优势 -->
                    <!-- <div class="menu-container">
                        <router-link class="menu-title" to="/home/core">{{$t("menu.l5")}}</router-link>
                    </div> -->

                    <!-- 新闻中心 -->
                    <div class="menu-container">
                        <router-link class="menu-title" to="/home/news">{{$t("menu.l6")}}</router-link>
                    </div>

                    <!-- 加入我们 -->
                    <div class="menu-container">
                        <router-link class="menu-title" to="/home/join">{{$t("menu.l7")}}</router-link>
                    </div>
                </div>
            </div>
            
            <div class="social-media-section flex-row justify-between medias">
                <!-- 微信图标及悬停大图 -->
                <div class="social-icon-container" @mouseenter="activeHover = 'wechat'" @mouseleave="activeHover = null">
                    <transition name="fade" mode="out-in">
                        <img v-if="activeHover !== 'wechat'" class="footer-icon" src="/static/img/icon_wechat.png" alt="微信"/>
                        <img v-else class="footer-large-icon" src="/static/img/qrcode_wechat.jpg" alt="微信大图"/>
                    </transition>
                </div>

                <!-- 抖音图标及悬停大图 -->
                <div class="social-icon-container" @mouseenter="activeHover = 'douyin'" @mouseleave="activeHover = null">
                    <transition name="fade" mode="out-in">
                        <img v-if="activeHover !== 'douyin'" class="footer-icon" src="/static/img/icon_douyin.png" alt="抖音"/>
                        <img v-else class="footer-large-icon" src="/static/img/qrcode_douyin.jpg" alt="抖音大图"/>
                    </transition>
                </div>

                <!-- 小红书图标及悬停大图 -->
                <div class="social-icon-container" @mouseenter="activeHover = 'redbook'" @mouseleave="activeHover = null">
                    <transition name="fade" mode="out-in">
                        <img v-if="activeHover !== 'redbook'" class="footer-icon" src="/static/img/icon_redbook.png" alt="小红书"/>
                        <img v-else class="footer-large-icon" src="/static/img/qrcode_redbook.jpg" alt="小红书大图"/>
                    </transition>
                </div>

                <!-- 微博图标（保持原链接跳转） -->
                <!-- <a href="https://service.weibo.com/share/share.php?title=江苏林德曼新材料科技有限公司【官网】&url=www.jslindeman.com" 
                    target="_blank" class="social-icon-container">
                    <img class="footer-icon" src="/static/img/icon_weibo.png" alt="微博"/>
                </a> -->
            </div>

            <div v-if="lang == 'zh'" class="txt">
                COPYRIGHT @ 2026 版权所有 &nbsp;&nbsp; 江苏林德曼新材料科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;
                <a class="beian" href="https://beian.miit.gov.cn" target="_blank">苏ICP备2024076619号</a>
            </div>
            <div v-else class="txt">
                COPYRIGHT @ 2026 ALL RESERVED Copyright Jiangsu Lindeman Tech Co., Ltd.&nbsp;&nbsp; 
                <a class="beian" href="https://beian.miit.gov.cn" target="_blank">苏ICP备2024076619号</a>
            </div>
        </div>
    </div>
</template>

<script>
    import pubsub from 'pubsub-js'

    export default {
        data() {
            return {
                lang: localStorage.getItem('lindemanLocaleLanguage') ? localStorage.getItem('lindemanLocaleLanguage') : 'zh',

                scenes: [
                    {zh: '房车应用场景', en: 'RV Application Scenarios'},
                    {zh: '家居定制场景', en: 'Home Customization Scenarios'}
                ],

                spaces: [
                    {zh: '智慧厨房', en: 'Smart Kitchen'},
                    {zh: '智慧餐厅', en: 'Smart Restaurant'},
                    {zh: '智慧客厅', en: 'Smart Living Room'},
                    {zh: '智慧儿童房', en: 'Smart Children Room'},
                    {zh: '智慧衣帽间', en: 'Smart Wardrobe'},
                    {zh: '智慧卧室', en: 'Smart Bedroom'},
                    {zh: '智慧书房', en: 'Smart Study Room'},
                    {zh: '智慧玄关', en: 'Smart Entrance'},
                    {zh: '智慧卫浴', en: 'Smart Bathroom'},
                    {zh: '智慧洗衣房', en: 'Smart Laundry Room'}
                ],

                activeHover: null,
                activeMenu: null
            }
        },

        mounted() {
            // 订阅消息
            this.pid = pubsub.subscribe('lindemanLocaleLanguage', (msgName, data) => { this.lang = data }) 
        },

        beforeDestroy() {
            pubsub.unsubscribe(this.pid)
        },

        computed: {
            conceptBg(){
                return this.$route.path == '/home/build' && !this.$route.query.detail ? '#555555' : '#FFFFFF'
            }
        },

        methods: {
            // 跳转核心优势详情页
            goCore(){
                 this.$router.push({
                    path: '/home/core',
                    query: {
                        key: Math.random()
                    }
                })
            },

            // 跳转裕林科技板应用场景
            goScene(index){
                this.$router.push({
                    path: '/home/yulin/' + index,
                    query: {
                        key: Math.random()
                    }
                })
                this.activeMenu = null
            },

            // 跳转产品中心十大空间
            goSpace(index){
                this.$router.push({
                    path: '/home/product',
                    query: {
                        spaceIndex: index,
                        key: Math.random()
                    }
                })
                this.activeMenu = null
            },

            // 跳转关于我们详情页
            goAbout(hash){
                this.$router.push({
                    path: '/home/about',
                    hash: hash,
                    query: {
                        key: Math.random()
                    }
                }).then(() => {
                    // 确保路由跳转完成后再滚动
                    this.activeMenu = null
                }).catch(err => {
                    console.error('Navigation error:', err)
                    this.activeMenu = null
                })
            },

            // 跳转联系我们详情页
            goContact(){
                this.$router.push({
                    path: '/home/contact',
                    query: {
                        key: Math.random()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../static/css/pc/footer.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/Footer.vue